import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../assets/images/logo.webp';
export const OnboardingChoiceScreen = ({
    pageTitle = 'Welcome',
    title = "You're all set!",
    description,
    icon,
    onNewProject,
    onExistingProject,
    isContinuing = false,
}) => {
    return (
        <div className="modal-overlay auth-page">
            <div className="auth-page__header">
                <img
                    src={logo}
                    alt="Company Logo"
                    className="auth-page__logo"
                />
                <h1 className="auth-page__title">
                    {pageTitle}
                </h1>
            </div>

            <div className="modal-content auth-page__card auth-page__card--md">
                <div className="auth-page__center">
                    {icon && (
                        <FontAwesomeIcon
                            icon={icon}
                            className="auth-page__icon"
                        />
                    )}
                    <h2 className="modal-title modal-title--compact">{title}</h2>
                    <p className="auth-page__description">{description}</p>
                    <div className="auth-page__actions">
                        <button
                            type="button"
                            className="btn btn-primary btn--block"
                            disabled={isContinuing}
                            onClick={onNewProject}
                        >
                            Start a New Project
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn--block"
                            disabled={isContinuing}
                            onClick={onExistingProject}
                        >
                            {isContinuing ? (
                                <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Loading your projects...
                                </>
                            ) : (
                                'Work on an Existing Project'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
